import { useSearchParams } from "react-router-dom";
import { AccountsPanel } from "@/components/money/AccountsPanel";
import { BudgetPanel } from "@/components/money/BudgetPanel";
import { OwedPanel } from "@/components/money/OwedPanel";
import { PayoutsPanel } from "@/components/money/PayoutsPanel";
import { TransfersPanel } from "@/components/money/TransfersPanel";
import { PageHeader } from "@/components/ui/page-header";
import { TabPanel, Tabs, pickTab, type TabItem } from "@/components/ui/tabs";

const TABS = ["accounts", "transfers", "budget", "payouts", "owed"] as const;
type MoneyTab = (typeof TABS)[number];
const TAB_ITEMS: TabItem<MoneyTab>[] = [
  { id: "accounts", label: "Accounts" },
  { id: "transfers", label: "Transfers" },
  { id: "budget", label: "Budget" },
  { id: "payouts", label: "Payouts due" },
  { id: "owed", label: "Owed to people" },
];

export function MoneyPage() {
  const [params, setParams] = useSearchParams();
  const tab = pickTab(params.get("tab"), TABS, "accounts");
  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="Money"
        description="Where the money is - the bank, cash, the sister company, the directors - what moved between them, and what each bucket may spend this month."
      />
      <div>
        <Tabs
          label="Money"
          items={TAB_ITEMS}
          value={tab}
          onChange={(next) =>
            setParams(next === "accounts" ? {} : { tab: next }, { replace: true })
          }
        />
        <TabPanel id={tab}>
          {tab === "accounts" && <AccountsPanel />}
          {tab === "transfers" && <TransfersPanel />}
          {tab === "budget" && <BudgetPanel />}
          {tab === "payouts" && <PayoutsPanel />}
          {tab === "owed" && <OwedPanel />}
        </TabPanel>
      </div>
    </div>
  );
}
